import { useEffect, useMemo } from 'react';
import type { StanFilterValue } from '@/components/core-components/StanFilters/types';
import { useRecipientsStore } from '../stores';
import { transformFiltersToApiFormat } from '../logic';

/**
 * Hook to manage recipients filter state and transformation
 */
export const useRecipientsFilters = () => {
    const filterValues = useRecipientsStore(state => state.filterValues);
    const setFilterValues = useRecipientsStore(state => state.setFilterValues);
    const setTransformedFilters = useRecipientsStore(state => state.setTransformedFilters);

    // Transform filters to backend format
    const transformedFilters = useMemo(() => {
        return transformFiltersToApiFormat(filterValues);
    }, [filterValues]);

    useEffect(() => {
        setTransformedFilters(transformedFilters);
    }, [transformedFilters, setTransformedFilters]);

    const handleFilterChange = (newFilterValues: StanFilterValue[]) => {
        setFilterValues(newFilterValues);
    };

    const handleResetFilters = () => {
        setFilterValues([]);
    };

    return {
        filterValues,
        transformedFilters,
        handleFilterChange,
        handleResetFilters,
    };
};
